import messageBusMap from './messageBusMap';

/**
 * Use the messageBusMap to get the proper messageBus
 * object depending on user's location.
 * @return {Object} The object to use as messageBus
 */
const getMessageBus = () => {
  if (typeof messageBusMap === 'object' && messageBusMap !== null) {
    const location = window.location.href;

    let nameFromMap;
    Object.keys(messageBusMap).some(option => {
      nameFromMap = option;
      return messageBusMap[option].some(locationRegex => location.match(locationRegex));
    });

    let messageBusInstance = window;
    nameFromMap.split('.').forEach(property => {
      messageBusInstance = messageBusInstance[property];
    });

    return messageBusInstance || getFallbackMessageBus();
  }
  return getFallbackMessageBus();
};

function getFallbackMessageBus() {
  return (window.WH && window.WH.messageBus) || null;
}

export default getMessageBus;



// WEBPACK FOOTER //
// ./src/main/messageBusGetter.js